import React from "react"
import { Container } from "reactstrap"
import BlockTitle from "components/shared/BlockTitle"
import GallerySlider from "components/shared/GallerySlider"

const GalleryCarousel = (props) => {
	const { block } = props

	return(
		<Container className="pt-3 pb-5" fluid>
			{block.title && 
				<BlockTitle newsTitle primary template="featured">{block.title}</BlockTitle>
			}
			<GallerySlider images={block.images} displayMore={false} />
		</Container>
	)
}

export default GalleryCarousel